import React from 'react';
import styled, { keyframes } from 'styled-components';
import { screen } from '../_utils/mediaQueries';
export const LoadingSkeleton = ({ width, height, margin, variant }) => {
    return (React.createElement(StyledSkeleton, { "data-testid": "loading-skeleton", width: width, height: height, variant: variant, margin: margin }));
};
// Keyframes for the pulsing effect
const pulse = keyframes `
  0% {
    background-color: #e0e0e0;
  }
  50% {
    background-color: #f0f0f0;
  }
  100% {
    background-color: #e0e0e0;
  }
`;
const StyledSkeleton = styled.div `
  background-color: #e0e0e0;
  animation: ${pulse} 1.5s ease-in-out infinite;
  border-radius: 4px;
  width: ${({ width }) => width || '100%'};
  height: ${({ height, theme, variant }) => (variant && theme.fontSizes[variant].mobile) || height || '20px'};
  margin: ${({ margin }) => margin || '4px'};

  @media ${screen.mediumUp} {
    height: ${({ height, theme, variant }) => (variant && theme.fontSizes[variant].default) || height || '20px'};
  }
`;
